import { Component } from '@angular/core';

@Component({
  selector: 'ncp-no-access-error',
  imports: [],
  templateUrl: './no-access-error.component.html',
  styleUrl: './no-access-error.component.scss',
})
export class NoAccessErrorComponent {}
